// TODO: Freeze UI while uploading database
// TODO: Add error and success states
// TODO: Force user to create a new campaign after leads are uploaded to this campaign

import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

import axios from 'axios';

import StandardPageTemplate from '../../templates/StandardPage';
import Table from '../../atoms/Table';
import TableBody from '../../atoms/TableBody';
import TableData from '../../atoms/TableData';
import TableHead from '../../atoms/TableHead';
import TableHeader from '../../atoms/TableHeader';
import TableRow from '../../atoms/TableRow';

function fetch_campaigns (cb) {
  axios.get('/fetch_campaigns/')
    .then((results) => {
      if (results.data.status !== 'OK') {
        throw new Error('Unable to fetch campaigns.');
      } else {
        cb(results.data.campaigns);
      }
    });
}

const CampaignListItem = ({ data }): JSX.Element => {
  return(
    <TableRow>
      <TableData>
        { data.id }
      </TableData>
      <TableData>
        { data.name ? data.name : <em>No file name.</em>}
      </TableData>
      <TableData>
        { data.createdAt }
      </TableData>
      <TableData>
        { data.count } row(s)
      </TableData>
      <TableData>
        <Link to={ `${data.id}` } >View Data</Link>
      </TableData>
    </TableRow>
  );
};

const CampaignsPage = (): JSX.Element => {
  const [campaigns, setCampaigns] = useState(null);
  const [campaignEls, setCampaignEls] = useState<JSX.Element[]>(null);

  useEffect(() => {
    if (!campaigns) {
      fetch_campaigns(setCampaigns);
    } else {
      const Campaigns: JSX.Element[] = [];
      for (let i = 0; i < campaigns.length; i++) {
        Campaigns.push(
          <CampaignListItem key={i} data={campaigns[i]} />
        );
      }
      setCampaignEls(Campaigns);
    }
  }, [campaigns]);
  return (
    <StandardPageTemplate>
      {
        !campaigns
          ? 'Loading...'
          : <div>
              <h1 className="f-serif f-normal">View Past Uploads</h1>
              <p>Uploads are sorted from newest to oldest.</p>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableHeader>
                      ID
                    </TableHeader>
                    <TableHeader>
                      Name
                    </TableHeader>
                    <TableHeader>
                      Date Created
                    </TableHeader>
                    <TableHeader>
                      Rows
                    </TableHeader>
                    <TableHeader>
                      Action
                    </TableHeader>
                  </TableRow>
                </TableHead>
                <TableBody>
                  { campaignEls }
                </TableBody>
              </Table>
            </div>
      }
    </StandardPageTemplate>
  );
};

export default CampaignsPage;
